import { Directive } from '@angular/core';
import { AbstractControl, ValidatorFn, Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

//validation function
function validateDropdownFactory(): ValidatorFn {
    return (c: AbstractControl) => {
        let isValid = c.value !== null;

        if (isValid) {
            return null;
        }
        else {
            return {
                choiceRequired: {
                    valid: false
                }
            };
        }
    }
}

@Directive({
    selector: '[choiceRequired][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: ChoiceRequired, multi: true }
    ]
})
export class ChoiceRequired implements Validator {
    validator: ValidatorFn;

    constructor() {
        this.validator = validateDropdownFactory();
    }

    validate(c: FormControl) {
        return this.validator(c);
    }
}